const { ajax } = require("@/js/WP_api.js");
import icon from '@/components/iconImage.vue';

const getMixin = () => {
    return {
        data() {
            return {
                isLoading: false,
                mouse: { x: 0, y: 0 }
            };
        },
        components: { icon },
        methods: {
            async $ajax(action, data, nameParam = "data") {
                this.isLoading = true;
                const st = await ajax(action, data, nameParam);
                this.isLoading = false;
                return st;
            },
        },
        mounted() {
            if (!this.$mouse) document.addEventListener('click', (event) => {
                this.mouse = { x: event.clientX, y: event.clientY }
                console.log("Mouse:", this.mouse)
                this.$eventBus.emit("mousePosition", this.mouse)
            });
        },
        computed: {
            $api() {
                return {
                    call: async(action, data, nameParam = "data") => {
                        this.isLoading = true;
                        const st = await ajax(action, data, nameParam);
                        this.isLoading = false;
                        console.log("Api:", st.data)
                        if (st.status === true && st.data.callBack) {
                            this.$eventBus.emit("redirectPage", { callBack: st.data.callBack, msgCallBack: st.data.msgCallBack, btnCallBack: st.data.btnCallBack })
                        }
                        return st;
                    }
                };
            }
        }
    }
}

export {
    getMixin
}